import { render } from "./contact-and-social-buttons.vue?vue&type=template&id=4a7a2454&scoped=true"
import script from "./contact-and-social-buttons.vue?vue&type=script&lang=js"
export * from "./contact-and-social-buttons.vue?vue&type=script&lang=js"

import "./contact-and-social-buttons.vue?vue&type=style&index=0&id=4a7a2454&lang=scss&scoped=true"

import exportComponent from "/home/gebruiker/www/fresh/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a7a2454"]])

export default __exports__